






import {Component, Vue} from "vue-property-decorator";
import FilmDetails from "@/components/FilmDetails.vue";
import ContentPage from "@/components/ContentPage.vue";

@Component({
  components: {
    ContentPage,
    FilmDetails
  }
})

export default class DetailPage extends Vue {
  get filmId () {
    return this.$route.params.id
  }
}
